module.exports = __webpack_public_path__ + "img/mission@2x.0d645d5.jpg";